import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';

function Copyright() {
  return (
    <React.Fragment>
      Copyright {new Date().getFullYear()} {'© '}
      <Link color="inherit" href="https://www.spatialbiz.com/">
      Spatial Business Systems, Inc.
      </Link>
    </React.Fragment>
  );
}

const iconStyle = {
  width: 48,
  height: 48,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'warning.main',
  mr: 1,
  '&:hover': {
    bgcolor: 'warning.dark',
  },
};


export default function AppFooter() {
  return (
    <Typography
      component="footer"
      sx={{ display: 'flex', bgcolor: 'secondary.light' }}
    >
      <Container sx={{ my: 8, display: 'flex' }}>
        <Grid container spacing={5}>
          <Grid item xs={6} sm={6} md={12}>
            <Grid
              container
              direction="column"
              justifyContent="flex-end"
              spacing={2}
              sx={{ height: 120 }}
            >
              <Grid item sx={{ display: 'flex' }} >
                <Box 
                  component="a" 
                  href="https://twitter.com/spatialbiz" 
                  sx={iconStyle} 
                  style={{ background: '#0d7abf' }}>
                  <TwitterIcon sx={{ color: "white" }}  />
                </Box>
                <Box
                  component="a"
                  href="https://www.linkedin.com/company/spatial-business-systems/"
                  sx={iconStyle}
                  style={{ background: '#0d7abf' }}
                >
                  <LinkedInIcon sx={{ color: "white" }}  />
                </Box>
                <Box
                  component="a"
                  href="https://www.youtube.com/channel/UCPhShrJ0bZuapffBmp7uN5g"
                  sx={iconStyle}
                  style={{ background: '#0d7abf' }}
                >
                  <YouTubeIcon sx={{ color: "white" }}  />                  
                </Box>
              </Grid>
              <Grid item>
                <Copyright />
              </Grid>
            </Grid>
          </Grid>
          
        </Grid>
      </Container>
    </Typography>
  );
}
